<template>
    <div id="app">
        <common-header></common-header>

        <div class="app-main">
            <router-view class="app-main__view"></router-view>
        </div>
        <float-bar></float-bar>
        <common-footer></common-footer>
    </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader.vue'
import CommonFooter from '@/components/CommonFooter.vue'
import FloatBar from '@/components/FloatBar.vue'

export default {
  name: 'App',
  components: {
    CommonHeader,
    CommonFooter,
    FloatBar
  }
}
</script>

<style lang="less">
#app {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
}
.app-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    &__view {
        flex: 1;
    }
}

@import "./style/index.less";
</style>



// WEBPACK FOOTER //
// src/App.vue